export default "__VITE_ASSET__BUFaJRMq__"